import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'
import { deleteUserSession } from '../../../data/userSessions'
import { UserFriendlyError } from '../../../model/Error'
import { addValid } from '../../../store/message'
import { userSessionsKeys } from './userSessions.keys'

export interface LogoutSessionsVariables {
  sessionIds: string[]
  successTitle: string
  successMessage?: string
}

/**
 * Déconnecte une ou plusieurs sessions (une session, un appareil multi-sessions,
 * ou l'ensemble des autres appareils) via des appels `DELETE /users/me/sessions/{id}`.
 */
export const useLogoutSessions = () => {
  const queryClient = useQueryClient()
  const dispatch = useDispatch()

  return useMutation({
    mutationFn: async ({ sessionIds }: LogoutSessionsVariables) => {
      const results = await Promise.all(sessionIds.map((id) => deleteUserSession(id)))
      const hasFailure = results.some(({ ok }) => !ok)

      if (hasFailure) {
        throw new UserFriendlyError(
          'error',
          'La déconnexion a échoué',
          'Une erreur est survenue. Veuillez réessayer.',
        )
      }
    },
    onSuccess: (_data, { successTitle, successMessage }) => {
      dispatch(addValid(successTitle, successMessage))
      queryClient.invalidateQueries({ queryKey: userSessionsKeys.devices })
    },
  })
}
